import { jsx as _jsx } from "react/jsx-runtime";
import globalStore from '../store';
var DomCanvas = function () {
    var _a = globalStore.useStoreState(function (store) { return store.playerStore; }), zoomLevel = _a.zoomLevel, canvasHeight = _a.canvasHeight, canvasWidth = _a.canvasWidth;
    return (_jsx("div", { style: { width: canvasWidth, height: canvasHeight }, 
        // width={canvasWidth}
        // height={canvasHeight}
        className: "domCanvas" }));
};
export default DomCanvas;
